import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DataOptions, DependOnOption, DisabledType } from '../common'

export class CheckboxDef {
  key?: string = uuid()
  type: 'checkbox' = 'checkbox'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: CheckboxOptions = new CheckboxOptions()
  rules?: Rule[]
}

export class CheckboxOptions {
  defaultValue?: Array<string | number> = []
  disabled?: DisabledType = false
  showLabel?: boolean = true
  labelWidth?: string | number
  required?: boolean = false
  options?: DataOptions = {}
  showQuestionIcon?: boolean = false
  onCheckBoxChange?: (value: any, form: Record<string, any>) => void
  questionIconFn?: (item: Record<string, any>) => void
}
